<template>

  <el-dialog title="微信登录" class="dialog" :visible.sync="_visible" width="360px" :close-on-click-modal="false" :close-on-press-escape="false">
    <iframe scrolling="no" width="300" height="360" frameBorder="0" allowTransparency="true" :src="setSrc" style="margin: auto;"></iframe>

    <span slot="footer" class="dialog-footer">
      <el-button @click="_visible=false">取消</el-button>
    </span>
  </el-dialog>


</template>

<script>
  export default {

    computed: {
      _visible: {
        get() {
          return this.visible
        },
        set() {
          this.$emit('wechatHidden')
        }
      },
      setSrc() {
        var _url = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + this.appid +
          '&scope=' + this.scope +
          '&redirect_uri=' + this.redirect_uri +
          '&state=' + this.state +
          '&login_type=jssdk&self_redirect=default&style=' + this.theme +
          '&href=' + this.href;
        return _url;
      },
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      appid: String,

      scope: String,

      redirect_uri: String,

      state: {
        type: String,
        default: 'bind'
      },

      theme: {
        type: String,
        default: 'black'
      },

      href: {
        type: String,
        default: 'https://i.xinmeibao.com/wechat.css'
      },
    },
  }

</script>

<style scoped>
  .dialog>>>.el-dialog__body {
    padding: 0
  }

</style>



// WEBPACK FOOTER //
// src/components/auth/WechatLogin.vue